module.exports = flarum.core.compat['components/SelectDropdown'];